// import components below
import PropTypes from 'prop-types';
import PageHeaderUI from 'components/UI/PageHeaderUI';

// main component
const EmergencyDepartmentHeader = ({ active }) => {
  return (
    <div className='admissionHeader'>
      <PageHeaderUI>
        <h4>Emergency Department Module</h4>
        <p>Dashboard / Emergency Department / {active}</p>
      </PageHeaderUI>
    </div>
  );
};

EmergencyDepartmentHeader.defaultProps = {
  active: '',
};

EmergencyDepartmentHeader.propTypes = {
  active: PropTypes.string,
};

export default EmergencyDepartmentHeader;
